import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SnfReportingComponent } from './sfnReporting.component';

const routes: Routes = [
  {
    path: '',
    component: SnfReportingComponent,
    children: [
      // {
      //   path: 'esign',
      //   component: ESignatureComponent
      // },
    //   {
    //     path: 'createPermission',
    //     component: CreatePermissionComponent
    //   }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class snfreportingRoutingModule { }
